import { render, staticRenderFns } from "./externalRanap.vue?vue&type=template&id=627ff960"
import script from "./externalRanap.vue?vue&type=script&lang=js"
export * from "./externalRanap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627ff960')) {
      api.createRecord('627ff960', component.options)
    } else {
      api.reload('627ff960', component.options)
    }
    module.hot.accept("./externalRanap.vue?vue&type=template&id=627ff960", function () {
      api.rerender('627ff960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalRanap.vue"
export default component.exports